import { Component, OnDestroy, OnInit } from '@angular/core';
import { PurchaseOption } from '../../shared/models/app-models/PurchaseOption.model';
import { Store } from '@ngrx/store';
import { PurchaseOrderPopulator, PurchaseOrderImage, PurchaseOrderText, PurchaseOrderTitle, ContractPopulator, ContractImage, 
  ContractText, ContractTitle, OthersPopulator, OthersImage, OthersText, OthersTitle, } from '../../data/constants/Data';
import { MyPurchaseForm, PurchaseType } from 'src/app/shared/models/app-models';
import { Observable, Subject, combineLatest, map, takeUntil } from 'rxjs';
import { clearStore } from 'src/app/core/store/form.actions';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { environment } from 'src/environments/environment';
import { clearTaggingStore } from 'src/app/core/store/TaggedVendors.action';
import { clearAttachmentStore } from 'src/app/core/store/attachment.action';
import { clearDeletedItemVendorStore } from 'src/app/core/store/DeletedItemVendors.action';
import { AlertType } from 'src/app/shared/components/alert/alert.component';
import { AbilityService } from '@casl/angular';
import { PureAbility } from '@casl/ability';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GuideMeDialogComponent } from './guide-me/guide-me-dialog.component';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-purchase-modes',
  templateUrl: './purchase-modes.component.html',
  styleUrls: ['./purchase-modes.component.scss'],
})
export class LandingPageComponent implements OnInit, OnDestroy {
  floatText: string = 'Get Started';
  floatHover: boolean = false;
  purchaseOrder: PurchaseOption[] = PurchaseOrderPopulator;
  purchaseOrderImg: string = PurchaseOrderImage;
  purchaseOrderTitle: string = PurchaseOrderTitle;
  purchaseOrderText: string = PurchaseOrderText;
  contract: PurchaseOption[] = ContractPopulator;
  contractImg: string = ContractImage;
  contractTitle: string = ContractTitle;
  contractText: string = ContractText;
  others: PurchaseOption[] = OthersPopulator;
  othersImg: string = OthersImage;
  othersTitle: string = OthersTitle;
  othersText: string = OthersText;
  form!: MyPurchaseForm;
  destroy$: Subject<boolean> = new Subject<boolean>();
  permissionData$: Observable<any>
  canAccessSvp: boolean = false
  showInfoAlert:boolean=true;

  constructor(private _snackBar: MatSnackBar, private store: Store<{ form: MyPurchaseForm }>, private dialog: MatDialog, private dialogRef: MatDialogRef<any>, private permissionsService: PermissionsService,
    private keycloakService: KeycloakService
  ) {
    this.permissionData$ = this.permissionsService.getService().pipe(takeUntil(this.destroy$));
    if (localStorage.getItem('mypurchase_alert_airlines-not-allowed-rfq') && localStorage.getItem('mypurchase_alert_airlines-not-allowed-rfq') === 'Hide') {
      this.showInfoAlert = false;
    }
  }

  ngOnInit(): void {
    try {
      //re-inits
      this.store.dispatch(clearStore());
      this.store.dispatch(clearTaggingStore());
      this.store.dispatch(clearAttachmentStore());
      this.store.dispatch(clearDeletedItemVendorStore());
      this.permissionData$.subscribe(data => {
        this.canAccessSvp = data.ability.can('create', 'document', PurchaseType.SMALL)
        console.log('can access svp', this.canAccessSvp)
      })
      let smallValuePurchase = this.purchaseOrder.find((option) => option.title === 'Small Value Purchase') ?? null;
      if (smallValuePurchase) {
        let mmsRedirector = this.mmsRedirectDiaglog.bind(this);
        smallValuePurchase.setClickFunction(mmsRedirector);
        if(!this.keycloakService.getUserRoles().some((role) => role == "MP_MMS_PO_CREATE_OWNER")) {
          smallValuePurchase.setDisabled(true);
        }
      }
    } catch (err) {
      console.log('unable to clear the store due to: ', err);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  openSnackBar(notifMsg: string, type?: string) {
    this._snackBar.open(notifMsg, undefined, {
      verticalPosition: 'top',
      panelClass: type == 'success' ? 'snackbar-popup' : 'app-notification-error',
      duration: 5000,
    });
  }

  mmsRedirectDiaglog() {
    if (!this.canAccessSvp) {
      this.openSnackBar('You are not authorised to access this route')
      return
    }
    this.dialogRef = this.dialog.open(DialogComponent, {
      // height: '200px',
      // width: '450px',
      panelClass: 'item-vendor-dialog',
      hasBackdrop: true,
      data: {
        headerTitle: 'For small value purchase, you shall raise purchase order directly',
        contentMsg: 'Are you sure you want to proceed?',
        btnNameOne: 'Ok',
        btnNameTwo: 'Cancel',
        click: () => {
          alert("Redirecting to MMS Purchase Order");
          this.goMMSPO()
          this.dialogRef.close();
        },
        clickTwo: () => {
          this.dialogRef.close();
        }
      },
    });
  }

  goMMSPO() {
    window.location.href = this.getMMSPOUrl();
  }

  getMMSPOUrl() {
    return `${environment.mmsURL}/${environment.mmsPOPath}`
  }

  onFloatClick() {
    this.dialogRef = this.dialog.open(GuideMeDialogComponent, {
      data: {
        headerTitle: 'Guide Me',
        buttonsHeader: 'What is your estimated cost of purchase (SGD), excluding GST?',
        dropDownHeader: 'Select the option that best describes your purpose of purchase'
      },
    });
  }

  public get alertType(): typeof AlertType {
    return AlertType;
  }
}
